var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleBlueCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "checkmark-circle",
    d: "M21.375,3.375a18,18,0,1,0,18,18A18.021,18.021,0,0,0,21.375,3.375Zm9.367,11.968L19.112,29.189a1.385,1.385,0,0,1-1.039.494h-.023a1.385,1.385,0,0,1-1.029-.459l-4.985-5.538a1.384,1.384,0,1,1,2.058-1.852l3.919,4.355L28.622,13.561a1.385,1.385,0,0,1,2.121,1.781Z",
    transform: "translate(-3.375 -3.375)",
    fill: "#1c64f2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleBlueCheck);
export default __webpack_public_path__ + "static/media/circle-blue-check.34760a788c50dd0e46d09a91d1dcc60d.svg";
export { ForwardRef as ReactComponent };